<div class="payment-method-logo sports-only payment-method-{{ usedOption()?.paymentMethod }}"></div>
@if (usedOption()?.paymentMethod?.toUpperCase() == 'APPLEPAYDIRECT') {
    <div class="payment-methodName">{{ 'PARTY.CASHIER.web.common.applepaydirect.name' | translate }}</div>
} @else if (usedOption()?.paymentMethod?.toUpperCase() === 'INTERCHECKS_ACH') {
    <div class="d-flex flex-column">
        <div class="payment-methodName pl-2 f-12">{{ 'PARTY.CASHIER.web.common.achInterchecks.name' | translate }}</div>
        <div class="payment-text">{{ usedOption()?.instrumentNumber }}</div>
    </div>
} @else if (usedOption()?.paymentMethod != 'GOOGLEPAY') {
    <div class="payment-text">
        {{ usedOption()?.instrumentNumber }}
    </div>
} @else {
    <div class="payment-methodName">{{ usedOption()?.paymentText }}</div>
}
@if (usedOption()?.sportsOnly && !usedOption()?.bankAccountsOnly) {
    <div class="sports-only-ribbon">
        <div class="ribbon-text">
            {{ 'PARTY.CASHIER.web.deposit.sports.only.ribbon.text' | translate }}
        </div>
    </div>
}
@if (usedOption()?.bankAccountsOnly && !usedOption()?.sportsOnly && isUSLabel()) {
    <div class="sports-only-ribbon wp-48">
        <div class="ribbon-text">
            {{ 'PARTY.CASHIER.web.deposit.bank.accounts.only.ribbon.text' | translate }}
        </div>
    </div>
}
